<script setup lang="ts">
const localePath = useLocalePath()
</script>

<template>
  <UApp>
    <div class="community-space min-h-screen flex flex-col bg-[var(--bg)]">
      <NuxtLink
        :to="localePath('/')"
        class="absolute left-6 top-6 z-50 flex items-center gap-3"
      >
        <img
          src="/images/logo.png"
          alt="ZeroToHero"
          class="size-10 rounded-xl"
        >
        <span class="text-xl font-bold">Zero To Hero</span>
      </NuxtLink>
      <ClientOnly>
        <UColorModeButton
          size="xs"
          variant="ghost"
          class="fixed right-4 top-4 z-50 w-8 h-8 rounded-[9px] text-[var(--text3)]"
        />
      </ClientOnly>
      <main class="flex-1 flex items-center justify-center">
        <slot />
      </main>
    </div>
  </UApp>
</template>
